// src/Dashboard/pages/teacher/Belts/components/BeltsDataTable.jsx

import React from "react";
import { FaHistory } from "react-icons/fa";

import {
  DEFAULT_BELT_PHOTO,
  DEFAULT_USER_PHOTO,
  formatDateFr,
  getAdherentGroupsLabel,
  getAdherentName,
  getAdherentPhoto,
  getCurrentBeltDate,
  getCurrentBeltImage,
  getCurrentBeltName,
} from "../utils/beltDashboardUtils";

export default function BeltsDataTable({
  adherents = [],
  beltHistories = {},
  selectedIds,
  allChecked,
  onToggleAll,
  onToggleOne,
  onOpenDrawer,
}) {
  return (
    <div className="hidden md:block">
      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900/60">
        <table className="min-w-[1080px] w-full">
          <thead>
            <tr className="bg-slate-50 text-xs uppercase tracking-wide text-slate-600 dark:bg-slate-900 dark:text-slate-300">
              <th className="w-12 px-4 py-3 text-left">
                <input
                  type="checkbox"
                  checked={allChecked}
                  onChange={(event) => onToggleAll(event.target.checked)}
                  className="h-4 w-4 rounded border-slate-300"
                  aria-label="Tout sélectionner"
                />
              </th>
              <th className="px-4 py-3 text-left font-bold">Adhérent</th>
              <th className="px-4 py-3 text-left font-bold">Naissance</th>
              <th className="px-4 py-3 text-left font-bold">Groupe(s)</th>
              <th className="px-4 py-3 text-left font-bold">
                Ceinture actuelle
              </th>
              <th className="px-4 py-3 text-left font-bold">Dernier passage</th>
              <th className="sticky right-0 z-20 w-32 bg-slate-50 px-4 py-3 text-right font-bold dark:bg-slate-900">
                Historique
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100 text-sm dark:divide-slate-800">
            {adherents.map((adherent) => {
              const checked = selectedIds.has(adherent.id);

              const beltName = getCurrentBeltName(adherent.id, beltHistories);
              const beltImage = getCurrentBeltImage(adherent.id, beltHistories);
              const lastDate = getCurrentBeltDate(adherent.id, beltHistories);
              const groupsLabel = getAdherentGroupsLabel(adherent);

              return (
                <tr
                  key={adherent.id}
                  className={`transition hover:bg-slate-50/80 dark:hover:bg-slate-800/40 ${
                    checked ? "bg-indigo-50/60 dark:bg-indigo-500/10" : ""
                  }`}
                >
                  <td className="px-4 py-3">
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={(event) =>
                        onToggleOne(adherent.id, event.target.checked)
                      }
                      className="h-4 w-4 rounded border-slate-300"
                      aria-label={`Sélectionner ${getAdherentName(adherent)}`}
                    />
                  </td>

                  <td className="px-4 py-3">
                    <div className="flex min-w-[230px] items-center gap-3">
                      <img
                        src={getAdherentPhoto(adherent)}
                        alt={getAdherentName(adherent)}
                        onError={(event) => {
                          event.currentTarget.src = DEFAULT_USER_PHOTO;
                        }}
                        className="h-11 w-11 rounded-full object-cover ring-1 ring-slate-200 dark:ring-slate-700"
                      />

                      <div className="min-w-0">
                        <p className="truncate font-bold text-slate-900 dark:text-white">
                          {getAdherentName(adherent) || "—"}
                        </p>

                        <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">
                          Saison {adherent?.saison_active || "—"}
                        </p>
                      </div>
                    </div>
                  </td>

                  <td className="px-4 py-3 font-medium text-slate-700 dark:text-slate-200">
                    {formatDateFr(adherent.date_naissance)}
                  </td>

                  <td className="px-4 py-3">
                    <p className="line-clamp-2 max-w-[260px] text-slate-600 dark:text-slate-300">
                      {groupsLabel || "—"}
                    </p>
                  </td>

                  <td className="px-4 py-3">
                    <div className="flex min-w-[180px] items-center gap-3">
                      <img
                        src={beltImage}
                        alt={beltName || "Ceinture"}
                        onError={(event) => {
                          event.currentTarget.src = DEFAULT_BELT_PHOTO;
                        }}
                        className="h-8 w-fit object-contain"
                      />

                      <span className="font-bold text-slate-700 dark:text-slate-200">
                        {beltName || "—"}
                      </span>
                    </div>
                  </td>

                  <td className="px-4 py-3 font-medium text-slate-700 dark:text-slate-200">
                    {formatDateFr(lastDate)}
                  </td>

                  <td className="sticky right-0 z-10 bg-white px-4 py-3 text-right dark:bg-slate-900">
                    <button
                      type="button"
                      onClick={() => onOpenDrawer(adherent)}
                      className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#013E8E] px-3 py-2 text-xs font-bold text-white transition hover:bg-[#012f6c]"
                      title="Voir l’historique"
                    >
                      <FaHistory />
                      Ouvrir
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}